import type {
  FullHeadMPRToothFocusPayload,
  FullHeadMPRToothSliceDescriptorInput,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type { ToothSliceGeometry, ToothSliceDescriptor } from '../config';

import { toEngineOrientation } from './makeToothParityRequest';

const toEngineSliceDescriptor = (
  descriptor: ToothSliceDescriptor,
): FullHeadMPRToothSliceDescriptorInput | null => {
  const orientation = toEngineOrientation(descriptor.orientation);

  if (!orientation) {
    return null;
  }

  return {
    assetID: descriptor.assetID,
    imageHeight:
      descriptor.imageHeight === null
        ? undefined
        : Number(descriptor.imageHeight),
    imageWidth:
      descriptor.imageWidth === null
        ? undefined
        : Number(descriptor.imageWidth),
    order: descriptor.order,
    orientation,
    positionMm: descriptor.positionMm,
    strideMm: descriptor.strideMm,
    thicknessMm: descriptor.thicknessMm,
  };
};

export const makeToothFocusEnginePayload = (
  input: ToothSliceGeometry,
): FullHeadMPRToothFocusPayload => ({
  anatomicalBasis: {
    MesioDistal: input.anatomicalBasis.mesioDistal,
    VestibuloOral: input.anatomicalBasis.vestibuloOral,
    Axial: input.anatomicalBasis.crownRoot,
  },
  innerBox: input.roi.innerBox ?? undefined,
  iso: input.numeration.iso,
  isMissingTooth: input.isMissingTooth,
  origin: input.origin,
  outerBox: input.roi.outerBox,
  slices: input.sliceDescriptors
    .map(toEngineSliceDescriptor)
    .filter(
      (descriptor): descriptor is FullHeadMPRToothSliceDescriptorInput =>
        descriptor !== null,
    ),
  window: { wc: input.roi.windowLevel, ww: input.roi.windowWidth },
});
